import * as React from "react";
/* empty css                  */
const ButtonLoader = React.memo(() => /* @__PURE__ */ React.createElement("div", { "aria-hidden": "true", className: "button--loader" }));
export {
  ButtonLoader as default
};
//# sourceMappingURL=ButtonLoader.js.map
